import React from 'react';
import Timestamp from '../shared/Timestamp';

const isLater = (a, b) => !b || new Date(a) > new Date(b);

export default function DatasetCardTime({ dataset }) {
  const { type, last_synced_at: synced, last_sync_failed_at: failed } = dataset;
  if (type === 'synced' && failed && isLater(failed, synced)) {
    return (
      <>
        Last sync failed <Timestamp value={failed} />
        {synced && <>; data from <Timestamp value={synced} /></>}
      </>
    );
  }
  if (type === 'synced' && synced) {
    return <>Last synced: <Timestamp value={synced} /></>;
  }
  // A dataset that synced before sync times were recorded has data but no time yet.
  if (type === 'synced' && !dataset.file_summary?.complete) {
    return <>Not yet synced</>;
  }
  return <>Last Updated: <Timestamp value={dataset.last_activity_at || dataset.updated_at} /></>;
}
